export const LAB_FINDING_QUESTIONS = {
  cbc: {
    label: "CBC",
    date: "",
    description: "",
    order: 1,
  },
  cmp: {
    label: "CMP",
    date: "",
    description: "",
    order: 2,
  },
  a1c: {
    label: "A1C",
    date: "",
    description: "",
    order: 3,
  },
  flp: {
    label: "FLP",
    date: "",
    description: "",
    order: 4,
  },
  tsh: {
    label: "TSH",
    date: "",
    description: "",
    order: 5,
  },
  urinalysis: {
    label: "Urinalysis",
    date: "",
    description: "",
    order: 6,
  },
  toxicology: {
    label: "Toxicology",
    date: "",
    description: "",
    order: 7,
  },
  med_levels: {
    label: "Med Levels",
    date: "",
    description: "",
    order: 8,
  },
};
